import 'bootstrap/dist/css/bootstrap.css';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import './content/plugins/embla/embla.min.css';
import './content/style/dist/app.css';
import 'moment/locale/da';

import 'jquery/src/jquery';
import 'bootstrap/dist/js/bootstrap.js';
import './content/plugins/click-outside/jquery.ba-outside-events.js';

// Polyfills
import './infrastructure/polyfills/ArrayFind.js';
import './infrastructure/polyfills/StartsWith.js';
import './infrastructure/polyfills/FindIndex.js';
import './infrastructure/polyfills/svgxuse.js';
import './infrastructure/polyfills/ArrayIncludes.js';
import './infrastructure/polyfills/ArrayFill.js';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
//  import registerServiceWorker from "./registerServiceWorker";

import { BrowserRouter, Route } from 'react-router-dom';
import ScrollToTop from './uiComponents/layout/ScrollToTop';

ReactDOM.render(
    <BrowserRouter>
        <ScrollToTop>
            <Route path='/' component={App} />
        </ScrollToTop>
    </BrowserRouter>,
    document.getElementById('root') as HTMLElement
);
// registerServiceWorker();



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/index.tsx